// PLEASE UPDATE QUERY_OPTIONS_KEYS ARRAY WHENEVER QueryOptions INTERFACE IS UPDATED
// QUERY_OPTIONS_KEYS MUST INCLUDE ALL QueryOptions PROPERTIES
export interface QueryOptions {
  totalCount?: number;
  limit?: number;
  offset?: number;
  filter?: { [key: string]: any };
  sort?: { [key: string]: string };
  q?: string;
  order?: string;
  orderBy?: string;
  orderedIds?: Array<string>;
  userRegion?: string;
}

// PLEASE UPDATE QUERY_OPTIONS_KEYS ARRAY WHENEVER QueryOptions INTERFACE IS UPDATED
// QUERY_OPTIONS_KEYS MUST INCLUDE ALL QueryOptions PROPERTIES
export const QUERY_OPTIONS_KEYS = [
  'totalCount',
  'limit',
  'offset',
  'filter',
  'sort',
  'q',
  'order',
  'orderBy',
  'orderedIds',
];
